const routes = [
	/* @@GENERATOR:POD:ASSIGN */
	...require('~/pods/account/routes').default,
	...require('~/pods/authentication/routes').default,
	...require('~/pods/site/routes').default,
];

export default routes;
